import Vue from "vue";
import Vuex from "vuex";
import mutations from './mutation'
import magazine from '../services/magazine'
import inPlayer from '../services/inPlayer'
import cart from '../services/cart'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        issue:[],
        user: null
    },
    mutations,
    modules: {
        magazine,
        inPlayer,
        cart
    },
    getters: {
        isAuthenticated: state => !!state.user, // Verifica si hay un usuario autenticado
        getUser: state => state.user, // Devuelve los datos del usuario autenticado
    },
});